/**
 * What the Gemini proxy will talk to: the one list, read by both sides.
 *
 * The chat routes and the model test refuse every other version and model
 * (api/_lib/geminiUpstream.ts serves this module to them), and the /admin/ai
 * Models tab suggests and saves only these models. Two copies would let the tab
 * offer a model every chat then refuses, which is how this module came to be.
 *
 * A leaf module: it imports nothing, so the server can load it by a relative
 * path, as it loads src/services/looker/*.
 *
 * @module config/geminiAllowlist
 */

/** The two versions this proxy has ever been pointed at. */
export const ALLOWED_API_VERSIONS = ['v1', 'v1beta'] as const;

/**
 * Models the product actually asks for. Adding one here is a deliberate act —
 * which is the point. gemini-2.0-flash left on 2026-10-22: Google shut it down
 * on 2026-06-01, so every call to it failed upstream.
 */
export const ALLOWED_MODELS = [
  'gemini-2.5-flash',
  'gemini-2.5-flash-lite',
  'gemini-2.5-pro',
] as const;

export const isAllowedApiVersion = (v: string): boolean =>
  (ALLOWED_API_VERSIONS as readonly string[]).includes(v);

export const isAllowedModel = (m: string): boolean =>
  (ALLOWED_MODELS as readonly string[]).includes(m);
